<template>
  <div id="container" v-if="fetch_data">
    <section id="atusatus-entry">
      <div class="wrap">
        <div class="cts_box">
          <h1 class="main_ttl"><span>{{ fetch_data.title }}</span></h1>

          <div class="body_tbl">
            <h3 class="min_ttl"><span>エントリーの確認</span></h3>
            <p class="lead_txt">こちらの内容でエントリーしますか？</p>
          </div>
        </div>

        <div class="cts_box">
          <h3 class="min_ttl">エントリー内容</h3>

          <div class="df_table">
            <dl class="flex">
              <dt>銘柄コード</dt>
              <dd>{{ $store.state.entry.ticker }}</dd>
            </dl>
            <dl class="flex">
              <dt>銘柄名</dt>
              <dd>{{ $store.state.entry.name }}</dd>
            </dl>
            <dl class="flex">
              <dt>コメント</dt>
              <dd>{{ $store.state.entry.comment }}</dd>
            </dl>
          </div>

          <div class="button_wrap">
            <input type="button" class="submit light arrow" value="エントリーする" v-on:click="sendClicked()"
                   v-bind:disabled="disabled">
          </div>

          <div class="button_wrap mt20">
            <router-link :to="{ name: 'AtsuatsuEntry'}" class="submit arrow back light skeleton large">
              戻る
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'

export default {
  mixins: [Libraries],
  data() {
    return {
      disabled: false,
      fetch_data: null,
    }
  },
  mounted() {
    if (!this.$store.state.entry) {
      this.$router.push({name: 'AtsuatsuEntry'})
    } else {
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}stock_contest/last_contest.json`)
          .then(response => {
            this.fetch_data = response.data
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },
    sendClicked() {
      if (this.disabled) return

      this.disabled = true
      this.startAjax()
      this.axios
          .post(`${this.env.api_base_url}stock_contest/entry.json`, {
            ticker: this.$store.state.entry.ticker,
            // name: this.name,
            comment: this.$store.state.entry.comment
          })
          .then(() => {
            this.$router.push({name: 'AtsuatsuEntryFinish'})
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    }
  }
}
</script>
